import { render, staticRenderFns } from "./OrderBoxTabTitle.vue?vue&type=template&id=3b341190&scoped=true"
import script from "./OrderBoxTabTitle.vue?vue&type=script&lang=js"
export * from "./OrderBoxTabTitle.vue?vue&type=script&lang=js"
import style0 from "./OrderBoxTabTitle.vue?vue&type=style&index=0&id=3b341190&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b341190",
  null
  
)

export default component.exports